export const reloadApp = (goToRoot = false) => {
  if (goToRoot) {
    window.location.href = '/';

    return;
  }

  window.location.reload();
};
